module.exports = __webpack_public_path__ + "static/media/comm_es.744cbaa8.txt";